const API_URL = "https://guiview.com/api/";
const FILE_PATH = "https://guiview.com/api/admin-path/uploads";
//const FILE_PATH = "http://localhost:3001/admin-path/uploads";
//const API_URL = "http://localhost:3001/";

export { API_URL, FILE_PATH };
